import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SlipComponentHeaderComponent } from '../slip-component-header/slip-component-header.component';
import { ConsentInfo } from '../student-slip-modal.store';
import { StudentSlipConsentFormComponent } from './student-slip-consent-form/student-slip-consent-form.component';
import { StudentSlipConsentInfoComponent } from './student-slip-consent-info/student-slip-consent-info.component';

@Component({
  selector: 'app-student-slip-consent',
  templateUrl: './student-slip-consent.component.html',
  styleUrls: ['./student-slip-consent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SlipComponentHeaderComponent,
    StudentSlipConsentInfoComponent,
    NgClass,
    StudentSlipConsentFormComponent
  ]
})
export class StudentSlipConsentComponent implements OnInit {
  @Input() model: ConsentInfo;
  @Output() submitConsent = new EventEmitter<{ accepted: boolean }>();
  @Output() reloadSlip = new EventEmitter<void>();

  renderForm = false;

  ngOnInit(): void {
    // We are overlaying the form and info components if the form is being shown initially
    // such that the panel stays the same height during form completion.
    // This is to stop the view jumping around as the form is completed (see #10572)
    this.renderForm = !this.showInfo;
  }

  get showInfo(): boolean {
    return this.model.status === 'expired' || !!this.model.response;
  }
}
